import React from 'react'
import "./NewsCard.css"

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
}

function NewsCard(props) {
  const title = truncateText(props.title,50)
  return (
    <div className="news_card pb-3 h-100 " >
      <img src={props.img} className="card_img img-fluid" alt="blog thumbnail" />
      <div className="card_text d-flex flex-column align-items-start justify-content-between">
        
        <h4 className={`h4_main my-auto`}>
          <span className="card_title color-light">{title}</span>
        </h4>
        <div className='line-seprator'></div>
        <div className="d-flex justify-content-between w-100">
          <div className='d-flex align-items-center gap-2'>
              <p className='body-paragraph color-light mb-0'>{props.catagory}</p>
              <div style={{borderBottom:"1px solid #868686 ",width:"20px"}}></div>
              <p className='body-paragraph color-light mb-0'>7 MIN</p>
          </div>
          <p 
            className='body-paragraph color-light anchor mb-0'
            onClick={()=>{props.redirectionFunction(props.anchor)}}
          >Read More</p>
        </div>
      </div>
    </div>
  )
}

export default NewsCard